export const copyToClipboard = (text) => {
  if (window.clipboardData && window.clipboardData.setData) {
    return window.clipboardData.setData('Text', text)
  }
  if (
    document.queryCommandSupported &&
    document.queryCommandSupported('copy')
  ) {
    const textarea = document.createElement('textarea')
    textarea.textContent = text
    textarea.style.position = 'fixed'
    document.body.appendChild(textarea)
    textarea.select()
    try {
      return document.execCommand('copy')
    } catch (ex) {
      return false
    } finally {
      document.body.removeChild(textarea)
    }
  }
}

export const copyToClipboardNew = (path = '') => {
  // Create a textarea to select text

  const textarea = document.createElement('textarea')
  textarea.value = path
  textarea.style.position = 'fixed'
  document.body.appendChild(textarea)

  // Clear any pre existing selections
  window.getSelection().removeAllRanges()
  // Select the text inside the textarea
  let range = document.createRange()
  range.selectNode(textarea)
  window.getSelection().addRange(range)

  try {
    let successful = document.execCommand('copy')
    let msg = successful ? 'Path was copied' : 'Unable to copy'

    console.log(msg)
  } catch (err) {
    // console.log('Unable to copy');
  } finally {
    document.body.removeChild(textarea)
  }
}

export default copyToClipboard
